import React, { useState } from 'react';

import BaseLayout from '../../components/layout/BaseLayout';
import MainForm from '../../components/form/MainForm';
import TriggerForm from '../../components/form/TriggerForm';
import WorkflowCanvas from '../../components/workflow3/WorkflowCanvas';
import AiWorkflowForm from '../../components/workflow3/AiWorkflowForm';
import BotExecutions from './BotExecutions';
import WorkflowExecutions from './WorkflowExecutions';

const Sidebar = ({ toggleSidebar, openModal }) => {
  return (
    <div className="">
      <button
        onClick={openModal}
        className={`flex w-full cursor-pointer items-center justify-center gap-2 rounded-xl bg-primary-gradient px-3 py-2 text-white ${
          toggleSidebar && 'text-1xl font-bold'
        }`}
      >
        {toggleSidebar ? '+' : 'Create Trigger'}
      </button>
    </div>
  );
};

const Workflow = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const openModal = () => setModalOpen(true);
  const closeModal = () => setModalOpen(false);
  const [showWorkflowCanvas, setShowWorkflowCanvas] = useState(false);
  const [aiWorkflowModalOpen, setAiWorkflowModalOpen] = useState(false);
  const [workflowType, setWorkflowType] = useState('bot'); // bot, workflow

  return (
    <BaseLayout
      sidebar={<Sidebar />}
      tabBarAbsolute={true}
      createName="New Workflow"
      handleCreate={
        workflowType === 'bot' ? openModal : () => setShowWorkflowCanvas(true)
      }
      leftSide={
        workflowType === 'workflow' ? <WorkflowExecutions /> : <BotExecutions />
      }
    >
      <div className="flex h-full w-full flex-col gap-3">
        <MainForm setWorkflowType={setWorkflowType} />
        <TriggerForm isModalOpen={isModalOpen} closeModal={closeModal} />
        <div className="relative">
          <div className="absolute  -top-7 left-1/2 hidden w-full -translate-x-1/2 transform items-center justify-center gap-4 text-xs sm:flex">
            <button
              onClick={() => {
                if (workflowType === 'bot') openModal();
                else if (workflowType === 'workflow')
                  setShowWorkflowCanvas(true);
              }}
              className="flex items-center gap-2 rounded-lg border border-zinc-700 bg-zinc-800 py-1 transition-all duration-200 hover:bg-opacity-70 sm:px-3"
            >
              + Create workflow
            </button>
          </div>
        </div>
      </div>
      {showWorkflowCanvas && (
        <WorkflowCanvas
          closeModal={() => {
            setShowWorkflowCanvas(false);
          }}
        />
      )}
      {aiWorkflowModalOpen && (
        <AiWorkflowForm
          isModalOpen={aiWorkflowModalOpen}
          closeModal={() => setAiWorkflowModalOpen(false)}
        />
      )}
    </BaseLayout>
  );
};

export default Workflow;
